<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #menuLateral
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
  >
    <div class="sidenav-float">
      <app-menu-sidenav></app-menu-sidenav>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="sidenav-content">
    <div class="navbar-float" [ngClass]="{'p-desktop': menuLateral.opened}">
      <app-menu-navbar [menuLateral]="menuLateral"></app-menu-navbar>
    </div>
    <!-- Add Content Here -->
    <div class="content" [ngClass]="{'p-desktop': menuLateral.opened}">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
